import Header from "./HeaderPO";
import PODetails from "./PODetails";
import InfoCard from "./InfoCard";
import ItemsTable from "./ItemsTable";
import POFooter from "./POFooter";
import { useEffect, useState, useRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import PurchaseOrderForm from "./PurchaseOrderForm.main";

export default function PurchaseOrder() {
  const navigate = useNavigate();
  const serverURL = process.env.REACT_APP_URL;
  const token = localStorage.getItem("token");
  const location = useLocation();
  const [listLoading, setListLoading] = useState(false);
  const isViewMode = location.state?.mode === "view";
  const isEditMode = location.state?.mode === "edit";
  const [selectedHistory, setSelectedHistory] = useState(null);
  const pdfRef = useRef();
  const [errors, setErrors] = useState({});

  const poData = selectedHistory ? selectedHistory : location.state?.poData;
  const currentPO = selectedHistory?.snapshot || location.state?.poData;
  const [isPOData, setPOData] = useState({
    poNumber: "",
    poDate: new Date(),
    poDeliveryDate: "",
    productItems: [
      {
        id: 1,
        productName: null,
        quantity: null,
        rate: null,
        taxable: null,
        cgst: null,
        description: "",
        hsnSac: null,
        productId: "",
        sgst: null,
        igst: null,
        cess: null,
        total: null,
        productId: "",
      },
    ],
    grandTotal: 0,
    vendorId: "",
    vendorData: null,
    termsAndConditionsId: [],
    totalCGSTAmount: 0,
    totalSGSTAmount: 0,
    totalIGSTAmount: 0,
    totalCESSAmount: 0,
    campaignId: "",
  });

  useEffect(() => {
    if (!currentPO?.productItems?.length) return;

    if (currentPO?.productItems?.length != 0) {
      const totals = currentPO.productItems.reduce(
        (acc, item) => {
          const taxable = Number(item.taxable || 0);

          acc.poAmount += taxable;

          acc.totalCGSTAmount += (taxable * Number(item.cgst || 0)) / 100;

          acc.totalSGSTAmount += (taxable * Number(item.sgst || 0)) / 100;

          acc.totalIGSTAmount += (taxable * Number(item.igst || 0)) / 100;

          acc.totalCESSAmount += (taxable * Number(item.cess || 0)) / 100;

          return acc;
        },
        {
          poAmount: 0,
          totalCGSTAmount: 0,
          totalSGSTAmount: 0,
          totalIGSTAmount: 0,
          totalCESSAmount: 0,
        },
      );

      const grandTotal =
        totals.poAmount +
        totals.totalCGSTAmount +
        totals.totalSGSTAmount +
        totals.totalIGSTAmount +
        totals.totalCESSAmount;

      setPOData((prev) => ({
        ...prev,
        ...currentPO,
        vendorData: currentPO.vendorId,
        ...(currentPO?.vendorId?.state != "Haryana"
          ? { isIGST: true }
          : { isIGST: false }),
        vendorId: currentPO.vendorId?._id || "",
        campaignId: currentPO.campaignId?._id || "",
        campaignData: currentPO.campaignId || {},
        poDeliveryDate: currentPO?.poDeliveryDate,
        poAmount: totals.poAmount,
        totalCGSTAmount: totals.totalCGSTAmount,
        totalSGSTAmount: totals.totalSGSTAmount,
        totalIGSTAmount: totals.totalIGSTAmount,
        totalCESSAmount: totals.totalCESSAmount,

        poDate: currentPO?.poDate,
        totalTax: currentPO?.isIGST
          ? totals?.totalIGSTAmount + totals?.totalCESSAmount
          : totals?.totalCGSTAmount +
            totals?.totalSGSTAmount +
            totals?.totalCESSAmount,
        ...totals,
        grandTotal,
      }));
    }
  }, [currentPO]);

  const downloadPDF = async () => {
    const element = pdfRef.current;

    const canvas = await html2canvas(element, {
      scale: 1.4,
      useCORS: true,
    });

    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    const imgWidth = pdfWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);

    heightLeft -= pdfHeight;

    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pdfHeight;
    }

    pdf.save(`PO-${isPOData.poNumber}.pdf`);
  };
  const [isCampaignList, setCampaignList] = useState([]);

  const getLatestPOName = async () => {
    try {
      const response = await axios.get(
        `${serverURL}/purchaseOrder/getLatestPONumber`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (response?.data?.success) {
        setPOData((prev) => ({ ...prev, poNumber: response.data.poNumber }));
      }
    } catch (error) {
      console.error("Error fetching latest PO Name:", error);
    }
  };

  const getAllCampaigns = async () => {
    setListLoading(true);
    try {
      const response = await axios.get(`${serverURL}/PDI/fetchCampaigns`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response?.data?.success) {
        setCampaignList(response.data.data || []);
        setListLoading(false);
      }
    } catch (error) {
      console.error("Error fetching Installation Partners:", error);
      setListLoading(false);
    }
  };

  useEffect(() => {
    if (!isViewMode) {
      getAllCampaigns();
    }
    if (!isViewMode && !isEditMode) {
      getLatestPOName();
    }
  }, []);
  const [showActionBar, setShowActionBar] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowActionBar(window.scrollY > 0); // Adjust 300 as needed
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const getCurrentFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth(); // Jan = 0, Apr = 3

    let startYear;
    let endYear;

    if (month >= 3) {
      // April to December
      startYear = year;
      endYear = year + 1;
    } else {
      // January to March
      startYear = year - 1;
      endYear = year;
    }

    return `${String(startYear).slice(-2)}-${String(endYear).slice(-2)}`;
  };
  const validatePO = () => {
    const newErrors = {};

    if (!isPOData.vendorId) {
      newErrors.vendorId = "Vendor is required";
    }

    if (
      !isPOData.locations ||
      !Array.isArray(isPOData.locations) ||
      isPOData.locations.length === 0
    ) {
      newErrors.locations = "Please select at least one location";
    }

    const productErrors = {};

    isPOData.productItems.forEach((item, index) => {
      const itemError = {};

      if (!item.productName) {
        itemError.productName = "Product is required";
      }

      if (!item.hsnSac || item.hsnSac == 0) {
        itemError.hsnSac = "HSN/SAC is required";
      }

      if (!item.quantity || item.quantity == 0) {
        itemError.quantity = "Quantity is required";
      }

      if (!item.rate || item.rate == 0) {
        itemError.rate = "Rate is required";
      }

      if (isPOData.isIGST) {
        if (!item.igst && item.igst !== 0) {
          itemError.igst = "IGST is required";
        }
      } else {
        if (!item.cgst && item.cgst !== 0) {
          itemError.cgst = "CGST is required";
        }
      }

      if (Object.keys(itemError).length > 0) {
        productErrors[index] = itemError;
      }
    });

    if (Object.keys(productErrors).length > 0) {
      newErrors.productItems = productErrors;
    }

    if (!isPOData.paymentTermId) {
      newErrors.paymentTermId = "Payment Term is required";
    }

    if (
      !isPOData.termsAndConditionsId ||
      isPOData.termsAndConditionsId.length === 0
    ) {
      newErrors.termsAndConditionsId =
        "Please select at least one Terms & Condition";
    }

    const financialYear = getCurrentFinancialYear();
    const poRegex = new RegExp(`^PO\\/${financialYear}\\/\\d{4}$`);

    if (!isPOData?.poNumber) {
      newErrors.poNumber = "PO Number is required";
    } else if (!poRegex.test(isPOData.poNumber)) {
      newErrors.poNumber = `PO Number must be in the format PO/${financialYear}/0001`;
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleGeneratePO = async () => {
    if (!validatePO()) {
      Swal.fire({
        icon: "warning",
        title: "Validation Error",
        text: "Please fill all required fields",
      });

      return;
    }

    try {
      Swal.fire({
        title: "Generating Purchase Order...",
        text: "Please wait while we create your PO.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const response = await axios.post(
        `${serverURL}/purchaseOrder/createPo`,
        isPOData, // Your payload
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      Swal.close();

      if (response.data.success) {
        await Swal.fire({
          icon: "success",
          title: "Purchase Order Generated",
          text: response.data.message || "Purchase Order created successfully.",
          confirmButtonText: "OK",
        });

        // Optional
        navigate("/adminPortal/purchaseOrder");
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: response.data.message || "Unable to generate Purchase Order.",
        });
      }
    } catch (error) {
      Swal.close();

      Swal.fire({
        icon: "error",
        title: "Something Went Wrong",
        text:
          error?.response?.data?.message ||
          error.message ||
          "Failed to generate Purchase Order.",
      });

      console.error("Generate PO Error:", error);
    }
  };
  const handlePOApproval = async (poId, status) => {
    let rejectionReason = "";

    if (status === "Rejected") {
      const reasonResult = await Swal.fire({
        title: "Reject Purchase Order",
        text: "Please provide the reason for rejection.",
        input: "textarea",
        // inputLabel: "Rejection Reason",
        inputPlaceholder: "Enter rejection reason...",
        inputAttributes: {
          "aria-label": "Rejection Reason",
        },
        showCancelButton: true,
        confirmButtonText: "Continue",
        cancelButtonText: "Cancel",
        inputValidator: (value) => {
          if (!value.trim()) {
            return "Rejection reason is required.";
          }
        },
      });

      if (!reasonResult.isConfirmed) return;

      rejectionReason = reasonResult.value;
    }

    const result = await Swal.fire({
      title: `${status === "Accepted" ? "Approve" : "Reject"} Purchase Order?`,
      text:
        status === "Accepted"
          ? "This Purchase Order will be approved."
          : "This Purchase Order will be rejected.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: status === "Accepted" ? "#16a34a" : "#dc2626",
      cancelButtonColor: "#6b7280",
      confirmButtonText: status === "Accepted" ? "Yes, Approve" : "Yes, Reject",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    try {
      const token = localStorage.getItem("token");

      await axios.put(
        `${serverURL}/purchaseOrder/editPO/${poId}`,
        {
          poStatus: status,
          emailCheck: true,
          rejectionReason, // Only populated for rejection
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      Swal.fire({
        icon: "success",
        title: "Success",
        text: `Purchase Order ${
          status === "Accepted" ? "approved" : "rejected"
        } successfully.`,
        timer: 1800,
        showConfirmButton: false,
      });
      navigate("/adminportal/purchaseOrder");

      // getAllPos(`page=${page}&limit=${pageSize}`);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error?.response?.data?.message ||
          "Something went wrong. Please try again.",
      });
    }
  };

  const handleUpdatePO = async () => {
    if (!validatePO()) {
      Swal.fire({
        icon: "warning",
        title: "Validation Error",
        text: "Please fill all required fields",
      });

      return;
    }

    try {
      Swal.fire({
        title: "Updating Purchase Order...",
        text: "Please wait while we update your PO.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const response = await axios.put(
        `${serverURL}/purchaseOrder/editPO/${poData._id}`,
        isPOData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      Swal.close();

      if (response.data.success) {
        await Swal.fire({
          icon: "success",
          title: "Purchase Order Updated",
          text: response.data.message || "Purchase Order updated successfully.",
          confirmButtonText: "OK",
        });
        navigate("/adminPortal/purchaseOrder");
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: response.data.message || "Unable to update Purchase Order.",
        });
      }
    } catch (error) {
      Swal.close();

      Swal.fire({
        icon: "error",
        title: "Something Went Wrong",
        text:
          error?.response?.data?.message ||
          error.message ||
          "Failed to update Purchase Order.",
      });

      console.error("Update PO Error:", error);
    }
  };
  const role = localStorage.getItem("role");
  return (
    <div className="min-h-screen bg-gray-100 p-4 md:p-8">
      {isViewMode && (
        <div
          className={`sticky top-0 z-50 flex w-full items-center justify-end gap-3
      border-b bg-white px-4 py-3 shadow-md
      transition-all duration-300
      ${
        showActionBar
          ? "translate-y-0 opacity-100"
          : "-translate-y-full opacity-0"
      }`}
        >
          {isPOData.poStatus === "Draft" && role == -1 ? (
            <div>
              <button
                onClick={() => handlePOApproval(isPOData._id, "Accepted")}
                className="rounded-lg bg-green-600 px-4 py-2 text-sm font-medium text-white hover:bg-green-700 m-1"
              >
                ✓ Approve
              </button>

              <button
                onClick={() => handlePOApproval(isPOData._id, "Rejected")}
                className="rounded-lg bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700"
              >
                ✕ Reject
              </button>
            </div>
          ) : (
            <span
              className={`rounded-full px-4 py-2 text-sm font-medium ${
                isPOData.poStatus === "Accepted"
                  ? "bg-emerald-100 text-emerald-700"
                  : "bg-red-100 text-red-700"
              }`}
            >
              {isPOData.poStatus === "Accepted"
                ? "Approved"
                : isPOData.poStatus == "Draft"
                  ? "Draft"
                  : "Rejected"}
            </span>
          )}

          <button
            onClick={downloadPDF}
            className="rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
          >
            ⬇ Download PDF
          </button>
        </div>
      )}
      <div className="mb-4 rounded-lg border bg-white p-4 shadow-sm">
        <h2 className="mb-3 text-lg font-semibold">Purchase Order History</h2>

        <div className="flex flex-wrap gap-3">
          <button
            onClick={() => setSelectedHistory(null)}
            className={`rounded-lg border px-4 py-2 ${
              !selectedHistory
                ? "border-blue-600 bg-blue-600 text-white"
                : "bg-white"
            }`}
          >
            Current
          </button>

          {isPOData.amendmentHistory
            ?.sort((a, b) => b.amendmentNo - a.amendmentNo)
            .map((item) => (
              <button
                key={item._id}
                onClick={() => setSelectedHistory(item)}
                className={`rounded-lg border px-4 py-2 ${
                  selectedHistory?._id === item._id
                    ? "border-blue-600 bg-blue-600 text-white"
                    : "bg-white"
                }`}
              >
                Amendment #{item.amendmentNo}
              </button>
            ))}
        </div>
      </div>

      <PurchaseOrderForm
        pdfRef={pdfRef}
        isPOData={isPOData}
        isViewMode={isViewMode || selectedHistory ? true : false}
        downloadPDF={downloadPDF}
        isCampaignList={isCampaignList}
        setPOData={setPOData}
        errors={errors}
        listLoading={listLoading}
        isEditMode={isEditMode}
        handleUpdatePO={handleUpdatePO}
        handleGeneratePO={handleGeneratePO}
        setErrors={setErrors}
      />
    </div>
  );
}
